/* Email auto-correction — fixes common domain typos on blur */
const DOMAIN_TYPOS = {
  // Gmail
  'gmal.com': 'gmail.com', 'gmial.com': 'gmail.com', 'gmaill.com': 'gmail.com',
  'gamil.com': 'gmail.com', 'gnail.com': 'gmail.com', 'gmai.com': 'gmail.com',
  'gmali.com': 'gmail.com', 'gmil.com': 'gmail.com', 'gail.com': 'gmail.com',
  'gemail.com': 'gmail.com', 'gimail.com': 'gmail.com', 'gmale.com': 'gmail.com',
  'gmaul.com': 'gmail.com', 'gmiail.com': 'gmail.com', 'gmaik.com': 'gmail.com',
  'gmaio.com': 'gmail.com', 'gmeil.com': 'gmail.com', 'gmqil.com': 'gmail.com',
  'gmail.co': 'gmail.com', 'gmail.con': 'gmail.com', 'gmail.cm': 'gmail.com',
  'gmail.om': 'gmail.com', 'gmail.cmo': 'gmail.com', 'gmail.comm': 'gmail.com',
  'gmail.coom': 'gmail.com', 'gmail.cim': 'gmail.com', 'gmail.vom': 'gmail.com',
  'gmal.co': 'gmail.com',
  // Hotmail
  'hotmal.com': 'hotmail.com', 'hotmial.com': 'hotmail.com', 'hotnail.com': 'hotmail.com',
  'hotamil.com': 'hotmail.com', 'hotmaill.com': 'hotmail.com', 'hotmai.com': 'hotmail.com',
  'hotmil.com': 'hotmail.com', 'hotmale.com': 'hotmail.com', 'hotmali.com': 'hotmail.com',
  'hotmeil.com': 'hotmail.com', 'hotamail.com': 'hotmail.com', 'htomail.com': 'hotmail.com',
  'htmail.com': 'hotmail.com', 'hotmaul.com': 'hotmail.com', 'hotmal.co': 'hotmail.com',
  'hotmail.co': 'hotmail.com', 'hotmail.con': 'hotmail.com', 'hotmail.cm': 'hotmail.com',
  'hotmail.om': 'hotmail.com', 'hotmail.cmo': 'hotmail.com', 'hotmail.comm': 'hotmail.com',
  // Yahoo
  'yaho.com': 'yahoo.com', 'yahooo.com': 'yahoo.com', 'yahho.com': 'yahoo.com',
  'yhaoo.com': 'yahoo.com', 'yaoo.com': 'yahoo.com', 'yhoo.com': 'yahoo.com',
  'yaaho.com': 'yahoo.com', 'yaboo.com': 'yahoo.com', 'uahoo.com': 'yahoo.com',
  'tahoo.com': 'yahoo.com', 'yshoo.com': 'yahoo.com', 'yahpp.com': 'yahoo.com',
  'yahoo.co': 'yahoo.com', 'yahoo.con': 'yahoo.com', 'yahoo.cm': 'yahoo.com',
  'yahoo.om': 'yahoo.com', 'yahoo.cmo': 'yahoo.com', 'yahoo.comm': 'yahoo.com',
  // Outlook
  'outloo.com': 'outlook.com', 'outlok.com': 'outlook.com', 'outloock.com': 'outlook.com',
  'outlool.com': 'outlook.com', 'outllok.com': 'outlook.com', 'oulook.com': 'outlook.com',
  'outllook.com': 'outlook.com', 'oultook.com': 'outlook.com', 'putlook.com': 'outlook.com',
  'outloook.com': 'outlook.com', 'outlokk.com': 'outlook.com', 'outluk.com': 'outlook.com',
  'outlook.co': 'outlook.com', 'outlook.con': 'outlook.com', 'outlook.cm': 'outlook.com',
  'outlook.om': 'outlook.com', 'outlook.cmo': 'outlook.com', 'outlook.comm': 'outlook.com',
  // iCloud
  'iclud.com': 'icloud.com', 'iclould.com': 'icloud.com', 'icoud.com': 'icloud.com',
  'icloude.com': 'icloud.com', 'iclod.com': 'icloud.com', 'icluod.com': 'icloud.com',
  'icloud.co': 'icloud.com', 'icloud.con': 'icloud.com', 'icloud.cm': 'icloud.com',
  // Live / MSN
  'live.co': 'live.com', 'live.con': 'live.com', 'live.cm': 'live.com',
  'lve.com': 'live.com', 'liive.com': 'live.com', 'lige.com': 'live.com',
  'msn.co': 'msn.com', 'msn.con': 'msn.com', 'msn.cm': 'msn.com',
  // Protonmail
  'protonmal.com': 'protonmail.com', 'protonmial.com': 'protonmail.com',
  'protonmali.com': 'protonmail.com', 'protnmail.com': 'protonmail.com',
  'protonmail.co': 'protonmail.com', 'protonmail.con': 'protonmail.com',
  // One.com (Scandinavian provider)
  'one.co': 'one.com', 'one.con': 'one.com', 'one.cm': 'one.com',
  'oen.com': 'one.com', 'onee.com': 'one.com', 'onne.com': 'one.com',
  'one.om': 'one.com', 'one.cmo': 'one.com', 'one.comm': 'one.com',
  // Simply.com (Danish provider)
  'simply.co': 'simply.com', 'simply.con': 'simply.com', 'simply.cm': 'simply.com',
  'simpy.com': 'simply.com', 'simpley.com': 'simply.com', 'simly.com': 'simply.com',
  'smiply.com': 'simply.com', 'simply.cmo': 'simply.com', 'simply.comm': 'simply.com',
};

const DOT_CO_PROVIDERS = new Set([
  'gmail', 'hotmail', 'yahoo', 'outlook', 'icloud', 'live',
  'protonmail', 'msn', 'aol', 'mail', 'ymail', 'one', 'simply',
]);

export const correctEmail = (raw) => {
  if (!raw || !raw.includes('@')) return raw;
  const trimmed = raw.trim();
  const atIdx = trimmed.lastIndexOf('@');
  const local = trimmed.substring(0, atIdx);
  let domain = trimmed.substring(atIdx + 1).toLowerCase();

  if (!domain) return trimmed;

  if (DOMAIN_TYPOS[domain]) return `${local}@${DOMAIN_TYPOS[domain]}`;

  domain = domain
    .replace(/\.con$/, '.com')
    .replace(/\.cmo$/, '.com')
    .replace(/\.comm$/, '.com')
    .replace(/\.coom$/, '.com');

  if (domain.endsWith('.co')) {
    const name = domain.slice(0, -3);
    if (DOT_CO_PROVIDERS.has(name)) domain = `${name}.com`;
  }

  return `${local}@${domain}`;
};

export default correctEmail;